import { PlatformData } from '../ModuleConfig';

export interface WebModuleConfigData extends PlatformData {
  '@type': 'type.googleapis.com/terra.v1.WebModuleConfigData';
  url: string;
  linkProcessorClass: string;
}

export const WebModuleConfigDataFields: (keyof WebModuleConfigData)[] = [
  'url',
  'linkProcessorClass',
];
